import React, { useState, useRef } from "react";
import { Auth } from "aws-amplify";
import ApiService from "../ApiService";
import { Card, Form, Button, Row, Col, Spinner } from "react-bootstrap";
import { parseAxiosError } from "../util/parserHelper";
import { BsReplyFill, BsXCircle } from "react-icons/bs";
import { AttachFile } from "@material-ui/icons";

const ReplyMessage = props => {
  const [customerId, setCustomerId] = useState("");
  const [messageUUID] = useState(props.messageUUID);
  const [loading, setLoading] = useState(false);
  const [fileUploading, setFileUploading] = useState(false); // State to track file upload
  const [files, setFiles] = useState([]); // State to store selected files
  const [attachmentUrls, setAttachmentUrls] = useState([]); // State for uploaded file URLs

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");

  const [selectedAttachment, setSelectedAttachment] = useState([]);
  const [subject, setSubject] = useState("");
  const [attachedFileS3URLs, setAttachedFileS3URLs] = useState([]);

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const fileInputRef = useRef(null);

  // Fetch customer ID
  Auth.currentSession()
    .then(sess => {
      setCustomerId(sess.getIdToken().getJwtToken());
    })
    .catch(err => {
      console.error(err);
    });

    const handleAttachmentClick = () => {
      if (selectedAttachment.length >= 5) {
        return handleSnackOpen("Only 5 files allowed at a time", "error");
      }
      fileInputRef.current.click();
    };
  
    const handleFileChange = async event => {
      const file = event.target.files[0];
      if (!file) return;
  
      setFileUploading(true); // Set file uploading state
      handleSnackOpen("Uploading File", "info");
  
      try {
        const resp = await ApiService.uploadFile(file, "MESSAGE_ATTACHMENTS");
        const { url } = resp?.data?.body || {};
        setSelectedAttachment([...selectedAttachment, { ...file, url }]);
        setAttachedFileS3URLs([...attachedFileS3URLs, url]);
        handleSnackOpen("Upload success", "success");
      } catch (err) {
        handleSnackOpen(`Upload failed: ${parseAxiosError(err)?.message || "unknown"}`, "error");
      } finally {
        setFileUploading(false); // Reset file uploading state
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      }
    };

  const handleSubmit = event => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      setLoading(true);
      const content = document.getElementById("content").value;
      async function postMessageReply() {
        try {
          // eslint-disable-next-line no-unused-vars
          const postMessageReply = await ApiService.postMessageReply({
            originalMessageUUID: messageUUID,
            content: content,
            attachmentUrls: attachedFileS3URLs
          })
            .then(resp => {
              if (window.location.pathname === "/MessageDetails" && resp?.data) {
                window.location.replace(`${process.env.REACT_APP_BASE_URL}/MessageDetails?messageId=${resp.data}`);
              } else {
                window.location.reload();
              }
            })
            .catch(error => {
              const msg = error?.response?.data?.message ?? error?.message;
              console.error(error);
              alert(msg);
            });
        } catch (err) {
          const msg = err?.response?.data?.message ?? err?.message;
          console.error(err);
          alert(msg);
        } finally {
          setLoading(false);
        }
      }
      postMessageReply();
    }
  };


  return (
    <Card body className="replyFullBody">
      <Card.Body className="replyDetailBody">
        <Card.Title className="replytitle" as={Row}>
          <Col><BsReplyFill /></Col>
          <Col className="text-right"><BsXCircle /></Col>
        </Card.Title>
        <hr />
        <Form className="needs-validation new_msg_form" id="msgSendForm" noValidate onSubmit={handleSubmit}>
          <textarea name="body" id="content" cols="30" rows="10" className="msg_text_input msg_inputs send_textarea"></textarea>
          <hr />
          <Row>
            <Button
              id="msg_reply"
              type="submit"
              className="replyButton sendButton"
              disabled={loading || fileUploading} // Disable button if loading or file uploading
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Send"} {/* Show spinner when loading */}
            </Button>
            <div
              onClick={handleAttachmentClick}
              style={{ cursor: "pointer", opacity: fileUploading ? 0.5 : 1 }} // Visual cue when disabled
              disabled={fileUploading} // Disable file button
            >
              <AttachFile style={{ color: "black", marginLeft: "10px" }} />
            </div>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
              multiple
              disabled={fileUploading} // Prevent file selection during upload
            />
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ReplyMessage;
